import { render } from "./BuilderHeader.vue?vue&type=template&id=35891fee&scoped=true&ts=true&lang=pug"
import script from "./BuilderHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderHeader.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderHeader.vue?vue&type=style&index=0&id=35891fee&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35891fee"]])

export default __exports__